export enum AvatarFitType {
  Cover = 'Cover',
  Contain = 'Contain'
}
